<template>
  <bm-text v-bind="$attrs" :value="value" @input="$emit('input', $event)">
    <template v-if="value" #readOnly>
      <v-container class="wrap fluid px-1">
        <v-row
          v-for="email in emailAddressList"
          :key="email"
          dense
          class="py-1"
        >
          <v-col>
            <a :href="emailHref(email)">{{ email }}</a>
          </v-col>
          <v-col cols="auto">
            <bm-btn icon button-type="ghost" @click="copyToClipboard(email)">
              <v-icon small>assignment</v-icon>
            </bm-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </bm-text>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "BmEmail",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup(props, context) {
    const emailHref = (email: string) => {
      return `mailto:${email}`;
    };

    const emailAddressList = computed(() => {
      return props.value.split(";");
    });

    const copyToClipboard = (email: string) => {
      navigator.clipboard.writeText(email);
    };

    return { emailAddressList, emailHref, copyToClipboard };
  },
});
</script>

<style lang="sass" scoped>
.wrap
  word-break: break-word
  max-height: 20ch
  overflow-y: auto
</style>
